// extracted by mini-css-extract-plugin
module.exports = {"option":"OptionSelect_option__2q5jg","focado":"OptionSelect_focado__38c-B"};